module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-main', [_c('v-container', {
    attrs: {
      "container--fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md3": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-12"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": _vm.logoPrimary
    }
  })]), _vm._v(" "), _c('v-card-text', {
    staticClass: "center-block"
  }, [_c('p', {
    staticClass: "user-reset"
  }, [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('b-card', {
    attrs: {
      "bg-variant": "light"
    }
  }, [_c('div', {
    class: {
      'has-error': (_vm.$v.user.password.$error && _vm.$v.user.password.$dirty)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "New Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }, function($event) {
        return _vm.$v.user.password.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.user.password.$error && _vm.$v.user.password.$dirty) ? _c('div', [(!_vm.$v.user.password.required) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Please enter new password")]) : _vm._e(), _vm._v(" "), (!_vm.$v.user.password.validPassword) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Password must contain number, uppercase, lowercase, special symbols and more than 8 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'has-error': _vm.$v.user.repeatPassword.$error && _vm.$v.user.repeatPassword.$dirty
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.repeatPassword),
      expression: "user.repeatPassword"
    }],
    staticClass: "margin-top-5 form-control",
    attrs: {
      "type": "password",
      "placeholder": "Repeat Password"
    },
    domProps: {
      "value": (_vm.user.repeatPassword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "repeatPassword", $event.target.value)
      }, function($event) {
        return _vm.$v.user.repeatPassword.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.user.repeatPassword.sameAsPassword && _vm.$v.user.repeatPassword.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Password is not matched")]) : _vm._e()]), _vm._v(" "), _c('b-button', {
    staticClass: "margin-top-5",
    attrs: {
      "block": "",
      "type": "submit",
      "variant": "primary"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("Reset Password")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c95bab32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResetPasswordPage.vue
// module id = 2288
// module chunks = 0